module.exports = __webpack_public_path__ + "media/images/bg-7f2269f96f21c9dc9c123592d54ad562.png";